import React, { useEffect, useState } from 'react'
import { CityDropdownForTrip, CommonInput, CrossButton, CustomSelect } from 'components'
import { errorSchema, utils } from 'helper';
import StorageService from "utils/StorageServices/StorageServices";
import toast from 'react-hot-toast';
import { AddButton } from 'components/common/CommonButton';
import { constant } from 'constants/constant';
import { createMarketDriver, editMarketDriver } from '_services/accountsServices/marketDriverServices';
import { getDashbordData, getStatesData, handleKeyDown } from '_services';
import { DatePickerComponent } from 'components/common/CommonDatePicker';
import { getCityLocationList } from '_services/accountsServices/cityLocationService';
import AddLocationModal from 'modals/AddLocationModal';
import FirmImg from '../../assets/img/firm.png'
import { getFirm, getUserFirm } from '_services/accountsServices/firmServices';
import { Link } from 'react-router-dom';

const getFormattedDate = (is_date = '') => {
    const today = is_date ? new Date(is_date) : new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

const formObj = {
    company_id: StorageService.getCompanyId(),
    name: '',
    contact_no: '',
    driver_type: '2',
    address_line1: '',
    state: {},
    city: {},
    pincode: '',
    alt_contact_no: '',
    licence_number: '',
    licence_expiry: '',
    aadhar_no: '',
    firm_id: {},
}

const AddEditMarketDriver = (props) => {
    let { isOpen, onClose, callBackDriver, driverModal = false, hideAddNewOption = true, branchFirmId } = props;
    const [formValue, setFormValue] = useState(formObj);
    const [formError, setFormError] = useState({});
    const [loading, setLoading] = useState(false);

    const [openLoction, setOpenLoction] = useState(false);
    const [stateValue, setStateValue] = useState({});

    const [activeTab, setActiveTab] = useState(1);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [firmDataList, setFirmDataList] = useState([]);

    const [userData, setUserData] = useState('')
    const companydetails = userData?.user_detail?.company_list?.find((i) => i?.company_id?._id === StorageService?.getCompanyId())
    const marketDriverPermission = companydetails?.company_id?.perms_market_driver

    const handleOnChange = async (name, value) => {
        const stateObj = { ...formValue, [name]: value };
        setFormValue(stateObj);

        if (!utils.isObjectKeyEmpty(formError)) {
            const validationResult = await utils.checkFormError(stateObj, errorSchema.createMarketDriverSchema);
            if (validationResult === true) {
                setFormError("");
            } else {
                setFormError(validationResult);
            }
        }
    };

    const apiCallingFunction = async (shouldCloseModal) => {
        try {
            if (isOpen?._id) {
                let obj = {
                    ...formValue,
                    firm_id: formValue?.firm_id?.value ? formValue?.firm_id?.value : '',
                    contact_no: formValue?.contact_no != null ? formValue?.contact_no : '',
                    aadhar_no: formValue?.aadhar_no != null ? formValue?.aadhar_no : '',
                    pincode: formValue?.pincode != null ? formValue?.pincode : '',
                    alt_contact_no: formValue?.alt_contact_no != null ? formValue?.alt_contact_no : '',
                    driver_id: formValue?._id
                }
                delete obj._id;

                console.log('obj', obj)
                const res = await createMarketDriver(obj);
                if (res?.responseCode === 200) {
                    setFormValue({});
                    setLoading(false);
                    toast.success('Market Driver Updated Successfully');
                    if (shouldCloseModal) {
                        handleSubmitClose()
                        callBackDriver(res?.data?.driver)
                    } else {
                        setActiveTab(1); // Reset tab to the first tab
                    }
                } else {
                    setLoading(false);
                }
            } else {
                let obj = {
                    ...formValue,
                    firm_id: formValue?.firm_id?.value ? formValue?.firm_id?.value : '',
                }
                const res = await createMarketDriver(obj);
                if (res?.responseCode === 200) {
                    setFormValue({});
                    setLoading(false);
                    toast.success('Market Driver Created Successfully');
                    if (shouldCloseModal) {
                        handleSubmitClose()
                        callBackDriver(res?.data?.driver)
                    } else {
                        setActiveTab(1); // Reset tab to the first tab
                    }
                } else {
                    setLoading(false);
                }
            }
        } catch (error) {
            setLoading(false);
        } finally {
            setIsButtonDisabled(false);
        }
    }

    const handleClick = async (e) => {
        e.preventDefault();
        if (activeTab === 2) {
            const validationResult = await utils?.checkFormError({ ...formValue, aadhar_no_mandatory: marketDriverPermission?.aadhar_no ? true : false, license_no_mandatory: marketDriverPermission?.license_no ? true : false }, errorSchema.createMarketDriverSchema);
            if (utils?.isObjectKeyEmpty(validationResult)) {
                setLoading(true);
                await apiCallingFunction(true); // Pass true to close the modal
                setFormError("");

            } else {
                setFormError(validationResult);
                setLoading(false);
            }
        } else {
            const validationResult = await utils?.checkFormError(formValue, errorSchema.createMarketDriverSchema);
            if (activeTab === 1) {
                if (utils?.isObjectKeyEmpty(validationResult)) {
                    setActiveTab(activeTab + 1);
                }
            } else {
                if (utils?.isObjectKeyEmpty(validationResult)) {
                    setActiveTab(activeTab + 1);
                }
            }
            setFormError(validationResult);
        }
    };

    const handleResetFormAndSubmit = async (e) => {
        e.preventDefault();
        setIsButtonDisabled(true); // Disable the button immediately
        if (activeTab === 2) {
            const validationResult = await utils?.checkFormError({ ...formValue, aadhar_no_mandatory: marketDriverPermission?.aadhar_no ? true : false, license_no_mandatory: marketDriverPermission?.license_no ? true : false }, errorSchema.createMarketDriverSchema);
            if (utils?.isObjectKeyEmpty(validationResult)) {
                setLoading(true);
                await apiCallingFunction(false);
                setFormValue((prevData) => ({
                    ...prevData,
                    company_id: StorageService.getCompanyId(),
                    name: '',
                    contact_no: '',
                    driver_type: '2',
                    alt_contact_no: '',
                    licence_number: '',
                    licence_expiry: '',
                    aadhar_no: '',
                }))
                setFormError("");

            } else {
                setFormError(validationResult);
                setLoading(false);
                setIsButtonDisabled(false); // Re-enable the button if validation fails
            }
        } else {
            const validationResult = await utils?.checkFormError(formValue, errorSchema.createMarketDriverSchema);
            setActiveTab(activeTab + 1);
            setFormError(validationResult);
            setIsButtonDisabled(false); // Re-enable the button if validation fails
        }
    }

    const maxLengthCheck = (object) => {
        if (object.target.value.length > object.target.maxLength) {
            object.target.value = object.target.value.slice(0, object.target.maxLength)
        }
    }

    const changeActiveTab = async (event, value) => {
        event.preventDefault();
        if (value > activeTab) {
            const validationResult = await utils.checkFormError(formValue, errorSchema.createMarketDriverSchema);
            if (validationResult === true) {
                setActiveTab(value);
            } else {
                setFormError(validationResult);
            }
        } else {
            setActiveTab(value);
        }
    };

    const getAllDashboardData = async (data) => {
        const postData = {
            company_id: data,
            select_company_id: 1,
        };
        try {
            let response = await getDashbordData(postData);
            if (response?.responseCode === 200) {
                StorageService.setLocalItem("userData", JSON.stringify(response.data));
                setUserData(response.data);
            } else {
                throw response?.responseMessage;
            }
        } catch (error) {
            if (error?.name === "TypeError") {
                // Handle network errors, such as a failed fetch request
                console.error("Network error:", error?.responseMessage);
            } else {
                // Handle other errors, such as a bad response
                console.error("Error:", error?.responseMessage);
            }
        } finally {
        }
    };

    useEffect(() => {
        if (!isOpen?._id) {
            setFormValue((s) => ({
                ...s,
                company_id: StorageService.getCompanyId(),
            }))
        }
        getAllDashboardData(StorageService?.getCompanyId())
    }, [StorageService.getCompanyId()])

    useEffect(() => {
        if (isOpen?._id) {
            setFormValue((s) => ({
                ...s,
                company_id: StorageService.getCompanyId(),
                name: isOpen?.name,
                contact_no: isOpen?.contact_no,
                driver_type: isOpen?.driver_type,
                alt_contact_no: isOpen?.alt_contact_no,
                licence_number: isOpen?.licence_number,
                licence_expiry: getFormattedDate(isOpen?.licence_expiry),
                aadhar_no: isOpen?.aadhar_no,
                address_line1: isOpen?.address_line1,
                state: (isOpen?.state?.label && isOpen?.state?.value && isOpen?.state?.lat && isOpen?.state?.long) ? {
                    label: isOpen?.state?.label ? isOpen?.state?.label : '',
                    value: isOpen?.state?.value ? isOpen?.state?.value : '',
                    lat: isOpen?.state?.lat != 'undefined' ? isOpen?.state?.lat : '',
                    long: isOpen?.state?.long != 'undefined' ? isOpen?.state?.long : '',
                } : {},
                city: isOpen?.city,
                pincode: isOpen?.pincode,
                _id: isOpen?._id,
                firm_id: {
                    label: isOpen?.firm_id?.firm,
                    value: isOpen?.firm_id?._id
                },
            }))
        }
    }, [isOpen])

    const handleSubmitClose = () => {
        if (driverModal) {
            onClose()
        } else {
            onClose(!isOpen)
        }
    }

    const getStatesByApi = async (countryCode, stateCode) => {
        try {
            let data = {
                countryCode: countryCode,
                stateCode: stateCode
            }
            let response = await getStatesData(data);
            if (response?.responseCode === 200) {
                setStateValue(response?.data[0]);
            }
        } catch (error) {
            toast.error("An unexpected error occurred. Please try again.")
        }
    }

    const fetchFromCity = async (search, page, limit) => {
        const res = await getCityLocationList({
            countryCode: "IN",
            stateCode: "",
            offset: page,
            limit,
            search,

        });
        if (res?.responseCode === 200) {
            const list = res?.data?.all_cities.map((c) => ({ ...c, _id: c.name, label: `${c.name}, ${c.stateName}` }))

            return {
                items: list,
                total: res?.data?.total_record,
            };
        } else {
            toast.error(res?.responseMessage);
        }
    };


    const handleCityChange = (data) => {
        handleOnChange("city", {
            label: data?.name,
            value: data?.name,
            lat: String(data?.latitude),
            long: String(data?.longitude)
        })

        getStatesByApi(data?.countryCode, data?.stateCode);

        // const stateDetails = State.getStateByCodeAndCountry(
        //     data?.stateCode,
        //     data?.countryCode
        // );
        // if (stateDetails?.name && stateDetails?.isoCode) {
        //     setStateValue(stateDetails)
        // }
    }

    useEffect(() => {
        if (stateValue?.name) {
            handleOnChange("state", {
                label: stateValue?.name, value: stateValue?.name, lat: String(stateValue?.latitude),
                long: String(stateValue?.longitude)
            })
        }
    }, [stateValue])

    const addNewItemHandler = (e) => {
        setOpenLoction(true)
    }


    const callBackDataMaps = async (data) => {
        handleCityChange(data, "city")
        fetchFromCity()

    }

    let gmapLocates = {
        isOpen: openLoction,
        closeModal: (e) => setOpenLoction(false),
        modalMainClass: "_dashCommon_Modal _mdModalLoction",
        modalTitle: 'Add Location',
        submitTitle: 'Add Location',
        callBackDataMap: callBackDataMaps
    };

    const getDataFirmList = async () => {
        try {
            let object = {
                company_id: StorageService.getCompanyId(),
            }
            const res = await getUserFirm(object);
            if (res?.responseCode == 200) {
                let apiData = res?.data?.firm_list?.map((el) => {
                    return {
                        label: el?.firm_id?.firm,
                        value: el?.firm_id?._id,
                    }
                })
                setFirmDataList(apiData);
                if (!isOpen?._id) {
                    if (apiData?.length === 1) {
                        setFormValue((s) => ({
                            ...s,
                            firm_id: apiData[0]
                        }))
                    } else {
                        setFormValue((s) => ({
                            ...s,
                            firm_id: {}
                        }))
                    }
                }
            }
        } catch (error) {
        }
    }

    useEffect(() => {
        getDataFirmList();
    }, [])

    useEffect(() => {
        if (firmDataList?.length > 0 && !isOpen?._id) {
            let findObject = firmDataList?.find((el) => el?.value === StorageService.getFirmId());
            setFormValue((s) => ({
                ...s,
                firm_id: findObject?.value ? findObject : {}
            }))
        }
    }, [StorageService.getFirmId(), firmDataList, isOpen])

    useEffect(() => {

        if (firmDataList?.length > 0 && !isOpen?._id) {
            const storageFirmId = StorageService.getFirmId();

            let findObject = firmDataList.find((el) => el?.value === storageFirmId);

            const branchFirm = branchFirmId?._id;
            let vehicleFirmObject = firmDataList.find((el) => el?.value === branchFirm);

            setFormValue((s) => ({
                ...s,
                ...(vehicleFirmObject ? { firm_id: vehicleFirmObject } : findObject ? { firm_id: findObject } : {})
            }));
        }
    }, [StorageService.getFirmId(), firmDataList, isOpen?._id, branchFirmId]);

    return (
        <>
            <div className={formValue?.firm_id?.label ? `offcanvas-header offcan_header` : `offcanvas-header`}>
                {formValue?.firm_id?.label ?
                    <div>
                        <h5 className="offcanvas-title">{isOpen?._id ? 'Edit Market Driver' : 'Add Market Driver'}</h5>
                        <p className='offcanvas_heading_head'>
                            <img src={FirmImg} className='firm_icon_img' /> {" "}
                            {formValue?.firm_id?.label ? formValue?.firm_id?.label : <Link to='/setting/firm'> Create Firm </Link>}
                        </p>
                    </div>
                    :
                    <h5 className="offcanvas-title">{isOpen?._id ? 'Edit Market Driver' : 'Add Market Driver'}</h5>
                }
                <CrossButton type="button" className="_switchBtn  __animEffect_btn" style={{ marginLeft: 'auto' }} onClick={() => onClose(!isOpen)}>
                    <svg className="cross" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none" >
                        <path
                            d="M12.5321 0.477671C12.4422 0.387555 12.3353 0.316061 12.2177 0.267281C12.1001 0.2185 11.9741 0.193391 11.8468 0.193391C11.7195 0.193391 11.5934 0.2185 11.4758 0.267281C11.3582 0.316061 11.2514 0.387555 11.1615 0.477671L6.40798 5.22143L1.6545 0.46795C1.56451 0.377952 1.45766 0.306563 1.34008 0.257857C1.22249 0.20915 1.09646 0.184082 0.969185 0.184082C0.84191 0.184082 0.715881 0.20915 0.598294 0.257857C0.480707 0.306563 0.373865 0.377952 0.283868 0.46795C0.19387 0.557947 0.122481 0.664789 0.0737746 0.782376C0.0250685 0.899963 -9.48274e-10 1.02599 0 1.15327C9.48275e-10 1.28054 0.0250684 1.40657 0.0737746 1.52416C0.122481 1.64175 0.19387 1.74859 0.283868 1.83858L5.03735 6.59206L0.283868 11.3455C0.19387 11.4355 0.122481 11.5424 0.0737746 11.66C0.0250685 11.7776 0 11.9036 0 12.0309C0 12.1581 0.0250685 12.2842 0.0737746 12.4017C0.122481 12.5193 0.19387 12.6262 0.283868 12.7162C0.373865 12.8062 0.480707 12.8776 0.598294 12.9263C0.715881 12.975 0.84191 13 0.969185 13C1.09646 13 1.22249 12.975 1.34008 12.9263C1.45766 12.8776 1.56451 12.8062 1.6545 12.7162L6.40798 7.9627L11.1615 12.7162C11.2515 12.8062 11.3583 12.8776 11.4759 12.9263C11.5935 12.975 11.7195 13 11.8468 13C11.974 13 12.1001 12.975 12.2177 12.9263C12.3353 12.8776 12.4421 12.8062 12.5321 12.7162C12.6221 12.6262 12.6935 12.5193 12.7422 12.4017C12.7909 12.2842 12.816 12.1581 12.816 12.0309C12.816 11.9036 12.7909 11.7776 12.7422 11.66C12.6935 11.5424 12.6221 11.4355 12.5321 11.3455L7.77861 6.59206L12.5321 1.83858C12.9015 1.46919 12.9015 0.847062 12.5321 0.477671Z"
                            fill="black" />
                    </svg>
                </CrossButton>
            </div>

            <div className="offcanvas-body">
                <div className='pr_procssBx'>
                    <div className='pr_procssBx_grid'>

                        {!isOpen?._id && firmDataList?.length > 1 && <div className='singleDiv'>
                            <CustomSelect
                                options={firmDataList}
                                label="Select Firm"
                                placeholder="Select Firm"
                                name="firm_id"
                                value={formValue?.firm_id}
                                error={formError["firm_id.label"]}
                                disabled={hideAddNewOption ? false : (formValue?.firm_id?.value ? true : false)}
                                onSelect={(data) => handleOnChange('firm_id', data)}
                            />
                        </div>}

                        <div className='singleDiv'>
                            <CommonInput
                                type="text"
                                placeholder="Driver Name"
                                label="Driver Name *"
                                name='name'
                                value={formValue.name}
                                focus={!!(typeof formError === "object" && formError?.name)}
                                error={!!(typeof formError === "object") ? formError?.name : ""}
                                maxLength="30"
                                onInput={utils.maxLengthCheck}
                                onChange={(e) => utils.handleNameInputChange(e, handleOnChange)}
                            // onChange={({ target: { name, value } }) =>
                            //     handleOnChange(name, value)
                            // }
                            />
                        </div>

                        <div className='singleDiv'>
                            <CommonInput
                                type="text"
                                placeholder="Mobile Number"
                                label='Mobile Number'
                                name='contact_no'
                                maxLength="16"
                                value={formValue.contact_no}
                                focus={!!(typeof formError === "object" && formError?.contact_no)}
                                error={!!(typeof formError === "object") ? formError?.contact_no : ""}
                                onInput={utils.maxLengthCheck}
                                onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}
                                onChange={(e) => utils.handleMobileInputChange(e, handleOnChange)}
                            // onChange={({ target: { name, value } }) =>
                            //     handleOnChange(name, value)
                            // }
                            />
                        </div>

                    </div>
                </div>

                <div className='addPr_flBx __newTabs_bx'>
                    <ul className="nav nav-tabs cstNew_tabs" id="addParty" role="tablist">
                        {constant.addMarketDriver?.map((item, indx) => (
                            <li
                                className="nav-item"
                                role="presentation"
                                key={indx + item?.value}
                            >
                                <button
                                    className={
                                        "nav-link " + (activeTab === item?.id ? "active" : "")
                                    }
                                    type="button"
                                    aria-selected={activeTab === item?.id}
                                    onClick={(e, val) => changeActiveTab(e, item.id)}
                                >
                                    {item?.title}
                                </button>
                            </li>
                        ))}
                    </ul>

                    {activeTab === 1 && (
                        <div className='pr_procssBx borderRmRf' id="addPartyContent">
                            <div className='pr_procssBx_grid'>

                                <div className='singleDiv'>
                                    <div className="h4Head">Add Address</div>
                                </div>

                                <div className='singleDiv'>
                                    <CommonInput
                                        type="text"
                                        placeholder="Address Line 1"
                                        label="Address Line 1"
                                        name='address_line1'
                                        value={formValue.address_line1}
                                        focus={!!(typeof formError === "object" && formError?.address_line1)}
                                        error={!!(typeof formError === "object") ? formError?.address_line1 : ""}
                                        onChange={({ target: { name, value } }) =>
                                            handleOnChange(name, value)
                                        }
                                    />
                                </div>

                                <div className='singleDiv'>
                                    <CityDropdownForTrip
                                        key={`fromLoction`}
                                        label="City "
                                        placeholder="Select a city"
                                        fetchData={fetchFromCity}
                                        isAddButton={true}
                                        addButtonAction={(e) => addNewItemHandler(e)}
                                        pageSize={20}
                                        onChange={(data) => handleCityChange(data, "city")}

                                        selectedItem={formValue?.city}
                                        error={!!formError["city.label"]}
                                        errorMessage={
                                            formError["city.label"]
                                        }
                                        withState={false}
                                    />
                                </div>

                                <div className='halfDiv'>
                                    <CommonInput
                                        type="text"
                                        placeholder="State"
                                        label="State"
                                        name='state'
                                        disabled={true}
                                        value={formValue?.state?.label}
                                        focus={!!(typeof formError === "object" && formError?.state)}
                                        error={!!(typeof formError === "object") ? formError?.state : ""}
                                        onChange={({ target: { name, value } }) =>
                                            handleOnChange(name, value)
                                        }
                                    />
                                </div>

                                <div className='halfDiv'>
                                    <CommonInput
                                        type="text"
                                        placeholder="PIN Code"
                                        label="PIN Code"
                                        name="pincode"
                                        maxLength={6}

                                        value={formValue.pincode}
                                        focus={!!(typeof formError === "object" && formError?.pincode)}
                                        error={!!(typeof formError === "object") ? formError?.pincode : ""}
                                        onChange={({ target: { name, value } }) => {
                                            if (/^\d*$/.test(value)) {
                                                handleOnChange(name, value);
                                                // setPhoneError("");
                                            }
                                        }}
                                    />
                                </div>

                                <div className='singleDiv'>
                                    <div className="h4Head">Other Contact</div>
                                </div>

                                <div className='singleDiv'>
                                    <CommonInput
                                        type="text"
                                        placeholder="Alternate Number"
                                        label="Alternate Number"
                                        name='alt_contact_no'
                                        maxLength="16"
                                        value={formValue.alt_contact_no}
                                        focus={!!(typeof formError === "object" && formError?.alt_contact_no)}
                                        error={!!(typeof formError === "object") ? formError?.alt_contact_no : ""}
                                        onInput={utils.maxLengthCheck}
                                        onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}
                                        onChange={(e) => utils.handleMobileInputChange(e, handleOnChange)}
                                    // onChange={({ target: { name, value } }) =>
                                    //     handleOnChange(name, value)
                                    // }
                                    />
                                </div>
                            </div>
                        </div>
                    )}

                    {activeTab === 2 && (
                        <div className='pr_procssBx' id="addPartyContent">
                            <div className='pr_procssBx_grid'>
                                <div className='halfDiv'>
                                    <CommonInput
                                        type="text"
                                        placeholder="e.g. MP09N-2020-1234567"
                                        label="License Number"
                                        name='licence_number'
                                        maxLength="18"
                                        onInput={handleKeyDown}
                                        value={formValue.licence_number}
                                        focus={!!(typeof formError === "object" && formError?.licence_number)}
                                        error={!!(typeof formError === "object") ? formError?.licence_number : ""}
                                        onChange={({ target: { name, value } }) =>
                                            handleOnChange(name, value.toUpperCase())
                                        }
                                    />
                                </div>

                                <div className='halfDiv'>
                                    {/* <CommonInput
                                        type="date"
                                        placeholder="Licence Expiry Date"
                                        label="Licence Expiry Date"
                                        name='licence_expiry'
                                        onKeyDown={(e) => e.preventDefault()}
                                        value={formValue.licence_expiry}
                                        focus={!!(typeof formError === "object" && formError?.licence_expiry)}
                                        error={!!(typeof formError === "object") ? formError?.licence_expiry : ""}
                                        onChange={({ target: { name, value } }) =>
                                            handleOnChange(name, value)
                                        }
                                    /> */}
                                    <DatePickerComponent
                                        label="Licence Expiry Date "
                                        name="licence_expiry"
                                        showTimeSelect={false}
                                        defaultTimeFix={false}
                                        startDate={formValue?.licence_expiry}
                                        onChange={(data) => handleOnChange('licence_expiry', data)}
                                        error={!!(typeof formError === "object") ? formError?.licence_expiry : ""}
                                    />
                                </div>

                                <div className='singleDiv'>
                                    <CommonInput
                                        type="text"
                                        placeholder="Aadhar Number e.g.111122223333"
                                        label='Aadhar Number'
                                        name='aadhar_no'
                                        maxLength="12"
                                        onInput={handleKeyDown}
                                        value={formValue.aadhar_no}
                                        focus={!!(typeof formError === "object" && formError?.aadhar_no)}
                                        error={!!(typeof formError === "object") ? formError?.aadhar_no : ""}
                                        onChange={({ target: { name, value } }) => {
                                            if (/^\d*$/.test(value)) {
                                                handleOnChange(name, value);
                                            }
                                        }}
                                    // onChange={({ target: { name, value } }) =>
                                    //     handleOnChange(name, value)
                                    // }
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                </div>

            </div>

            <div className='offcanvas-footer'>
                {
                    (activeTab === 2 ? (
                        <React.Fragment>
                            <AddButton onClick={handleClick} disabled={loading} name={isOpen?._id ? 'Update & Save' : 'Add Market Driver'} />
                            {!isOpen?._id ? <button
                                className={isButtonDisabled ? '_addNewComm_btn_disabled' : '_addNewComm_btn'}
                                onClick={handleResetFormAndSubmit}
                                disabled={isButtonDisabled || loading}

                            >
                                Add & New
                            </button> : <></>}
                        </React.Fragment>
                    ) : (
                        <AddButton onClick={handleClick} disabled={!formValue?.name} name='Continue' />
                    ))
                }
                {/* <button className='_addNewComm_btn' disabled={loading ? loading : (!formValue?.consignor_group_id || !formValue?.template_no || !formValue?.gst_treatment_id || !formValue?.gst_state)}>Add & New</button> */}
            </div>
            {openLoction && <AddLocationModal {...gmapLocates} />}
        </>
    )
}

export default AddEditMarketDriver